function getifyObject(n,r){var i=[];for(var e in r=r||"&",n)n.hasOwnProperty(e)&&["",null,void 0,NaN].indexOf(n[e])<0&&i.push(e+"="+n[e]);return i.join(r)}